import { LogLevel, TelemetryEvent } from "../../../common/telemetry/TelemetryConstants";
import { NotificationHandler } from "../../webchatcontainerstateful/webchatcontroller/notification/NotificationHandler";
import { NotificationScenarios } from "../../webchatcontainerstateful/webchatcontroller/enums/NotificationScenarios";
import { TelemetryHelper } from "../../../common/telemetry/TelemetryHelper";
import { defaultMiddlewareLocalizedTexts } from "../../webchatcontainerstateful/common/defaultProps/defaultMiddlewareLocalizedTexts";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleChatDisconnect = (props, state, setWebChatStyles) => {
  var _state$appStates, _state$domainStates, _state$domainStates$m, _props$webChatContain, _props$webChatContain2;
  const chatDisconnectState = state === null || state === void 0 ? void 0 : (_state$appStates = state.appStates) === null || _state$appStates === void 0 ? void 0 : _state$appStates.chatDisconnectEventReceived;
  const chatDisconnectMessage = (state === null || state === void 0 ? void 0 : (_state$domainStates = state.domainStates) === null || _state$domainStates === void 0 ? void 0 : (_state$domainStates$m = _state$domainStates.middlewareLocalizedTexts) === null || _state$domainStates$m === void 0 ? void 0 : _state$domainStates$m.MIDDLEWARE_BANNER_CHAT_DISCONNECT) ?? defaultMiddlewareLocalizedTexts.MIDDLEWARE_BANNER_CHAT_DISCONNECT;
  const hideSendBoxOnConversationEnd = props === null || props === void 0 ? void 0 : (_props$webChatContain = props.webChatContainerProps) === null || _props$webChatContain === void 0 ? void 0 : (_props$webChatContain2 = _props$webChatContain.renderingMiddlewareProps) === null || _props$webChatContain2 === void 0 ? void 0 : _props$webChatContain2.hideSendboxOnConversationEnd;
  switch (chatDisconnectState) {
    case true:
      if (hideSendBoxOnConversationEnd !== false) {
        setWebChatStyles(styles => {
          return {
            ...styles,
            hideSendBox: true
          };
        });
      }
      NotificationHandler.notifyWarning(NotificationScenarios.ChatDisconnect, chatDisconnectMessage);
      TelemetryHelper.logActionEvent(LogLevel.INFO, {
        Event: TelemetryEvent.ChatDisconnectThreadEventReceived,
        Description: "Chat disconnected due to timeout, left or removed."
      });
      break;
    case false:
      if (hideSendBoxOnConversationEnd !== false) {
        setWebChatStyles(styles => {
          return {
            ...styles,
            hideSendBox: false
          };
        });
      }
      break;
    default:
      break;
  }
};
export { handleChatDisconnect };